import React from "react"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import LimitInfo from "../styled/LimitInfo"

interface Props {
  maxPrice: number,
  currency: string
}

const WillReachMax = ({maxPrice, currency}) => (
  <LimitInfo>
    <FormattedMessage id="perks.components.productForms.willReachMax.text" />
    <FormattedCurrency isCents={false} value={maxPrice} currency={currency} />
  </LimitInfo>
)

export default WillReachMax
